<template>
    <div class="p-disclaimer">

      <div class="s-header">
      <div class="s-header-title">
        <ul class="f-xs">
          <li>
            <router-link class="l-rg p-cta" to="/people">Terms of Use and Disclaimers</router-link>
          </li>
        </ul>
      </div>
    <div class="s-text" style="margin-top: 1vw;">
      <div class="s-text-wrap" style="max-width: 70vw">
        <p class="f-md" data-animate="fade">
           By accessing this site, you acknowledge and consent to the following terms, conditions and disclaimers, which may be changed from time to time.
        </p>

        <p class="f-md" data-animate="fade">
          Nothing contained in the site constitutes investment, legal, tax or other advice or a recommendation or solicitation to buy or sell any security. VR Advisory Services Ltd (“VRASL”) and its affiliates provide no guarantee and accept no liability as to the accuracy, completeness or timeliness of the information provided on this site. You waive all rights and claims against VRASL in connection with your accessing and viewing this site or termination of access.
        </p>

        <p class="f-md" data-animate="fade">
          All information contained on this site belongs to VRASL and its affiliates who grant no rights to such content other than such rights as may be required by you to view this site, and you agree not to copy or otherwise create derivative works based on such materials.
        </p>
      </div>
    </div>
    </div>

    <Footer />

  </div>
</template>

<script>
import Footer from '@/components/footer/footer.vue';

export default {
  components: {
    Footer,
  },

  beforeCreate() {
    this.$root.$emit('closeMenu');
  },
};
</script>
